/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Create_HintInputs */

const cs_property_create_hint = /** @type {(inputs: Property_Create_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyplňte inzerát najednou v záložkách. Později můžete vše upravit na stránce nemovitosti.`)
};

const en_property_create_hint = /** @type {(inputs: Property_Create_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill the listing in one go using the tabs. You can refine anything later on the property page.`)
};

/**
* | output |
* | --- |
* | "Fill the listing in one go using the tabs. You can refine anything later on the property page." |
*
* @param {Property_Create_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_create_hint = /** @type {((inputs?: Property_Create_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Create_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_create_hint(inputs)
	return cs_property_create_hint(inputs)
});